export default __webpack_public_path__ + "static/media/151-sand-clock.051cc9e0.png";